export default function(router, store) {
  router.map({
    '/': {
      name: 'home',
      displayName: '清单',
      component: require('./views/home'),
      subRoutes: {
      }
    },
    '/error': {
      name: 'error',
      component: require('./views/error')
    },
    '/e/:id': {
      name: 'share',
      component: require('./views/home')
    }
  })

  router.alias({
    '/index': '/'
  })

  router.redirect({
    '*': '/' // default router
  })
}



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/